import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { HistoricoPacienteService } from '../../../../services/historico-paciente/historico-paciente.service';
import { CupomExibido, cuponsExibidos } from './agenda-cupons';

/** Cupons disponíveis do paciente, só para consulta: aplicar é no pagamento da conta. */
@Component({
  selector: 'app-agenda-cupons',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './agenda-cupons.component.html',
  styleUrl: './agenda-cupons.component.scss',
})
export class AgendaCuponsComponent implements OnChanges, OnDestroy {
  @Input() cdPessoaFisica: string | null = null;

  cupons: CupomExibido[] = [];
  carregando = false;
  erro = false;

  private seq = 0;

  constructor(private historico: HistoricoPacienteService) {}

  ngOnChanges() {
    void this.carregar();
  }

  ngOnDestroy() {
    this.seq++;
  }

  get total(): number {
    return this.cupons.reduce((s, c) => s + c.quantidade, 0);
  }

  private async carregar() {
    const seq = ++this.seq;
    this.cupons = [];
    this.erro = false;
    const cd = Number(this.cdPessoaFisica);
    if (!this.cdPessoaFisica || !cd) { this.carregando = false; return; }
    this.carregando = true;
    try {
      const lista = await this.historico.cupons(cd);
      if (seq === this.seq) this.cupons = cuponsExibidos(lista, new Date());
    } catch {
      if (seq === this.seq) this.erro = true;
    } finally {
      if (seq === this.seq) this.carregando = false;
    }
  }

  trackCupom(i: number, c: CupomExibido) { return `${c.codigo}_${i}`; }
}
